import Database from 'database';
import { Queue, Etapa } from 'models';
import Helpers from 'shared/helpers';
import { Creators as queueCreators } from './queue';

export const Types = {
  GET_ETAPAS: 'etapas/GET_ETAPAS',
  GET_ETAPAS_SUCCESS: 'etapas/GET_ETAPAS_SUCCESS',
  GET_ETAPAS_FAILED: 'etapas/GET_ETAPAS_FAILED',
  UPDATE_ETAPAS: 'etapas/UPDATE_ETAPAS',
  UPDATE_ETAPAS_SUCCESS: 'etapas/UPDATE_ETAPAS_SUCCESS',
  UPDATE_ETAPAS_FAILED: 'etapas/UPDATE_ETAPAS_FAILED',
};

const initialState = {
  data: [],
  error: null,
  loading: false,
};

export default function etapasReducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_ETAPAS:
      return { ...state, loading: true };
    case Types.GET_ETAPAS_SUCCESS:
      return { loading: false, ...action.payload };
    case Types.GET_ETAPAS_FAILED:
      return { ...state, loading: false, ...action.payload };
    case Types.UPDATE_ETAPAS:
      return { ...state, loading: true };
    case Types.UPDATE_ETAPAS_SUCCESS:
      return { ...state, ...action.payload };
    case Types.UPDATE_ETAPAS_FAILED:
      return { ...state, loading: false, ...action.payload };
    default:
      return state;
  }
}

export const Creators = {
  getEtapas: (id, condition) => async (dispatch) => {
    dispatch({ type: Types.GET_ETAPAS });
    try {
      const etapas = await Database.etapas
        .filter(
          (etapa) =>
            (condition ? condition(etapa) : true) &&
            (id
              ? String(etapa.pem_id) === String(id) ||
              String(etapa.pem) === String(id)
              : true),
        )
        .toArray();
      for (let i = 0; i < etapas.length; i++) {
        const etapa = etapas[i];
        etapas[i] = {
          ...etapa,
          id: etapa.id || etapa._id,
          pem_id: etapa.pem_id || id,
          produtos:
            etapa.produtos instanceof Array
              ? etapa.produtos
              : Object.values(etapa.produtos),
        };
      }
      dispatch({
        type: Types.GET_ETAPAS_SUCCESS,
        payload: {
          data: etapas.sort((e1, e2) => e1.ordem - e2.ordem),
          pem: id,
        },
      });
    } catch (oof) {
      console.error(oof.message);
      dispatch({
        type: Types.GET_ETAPAS_FAILED,
        payload: { error: oof.message },
      });
    }
  },
  updateEtapas: (pemId, form, etapas) => async (dispatch) => {
    dispatch({ type: Types.UPDATE_ETAPAS });
    const ids = [];
    const newEtapas = [];
    const etapasToCreate = [];
    const orderCadastradas = Object.keys(form.etapa_id).map((a) => String(a));
    try {
      // Prepare the objects
      Helpers.asyncForEach(Object.entries(form.etapa_id), async (etapa) => {
        const x = {
          pem: pemId,
          fenologica: form.fenologica[etapa[0]],
          aplicacao: form.aplicacao[etapa[0]],
          ordem: etapa[0],
          produtos: {},
        };
        await Helpers.asyncForEach(
          Object.entries(form.produtos[etapa[0]]),
          (produto) => {
            if (produto[1] === undefined) {
              return;
            }
            x.produtos[produto[0]] = {
              id: produto[1],
              quantidade: form.quantidade[etapa[0]][produto[0]] || 0,
              valor: form.valor[etapa[0]][produto[0]] || 0,
              fase_id: form.fase_id,
            };
          },
        );
        // If the form step is associated to an existing id
        if (etapa[1]) {
          x.id = etapa[1];
          // This should not be used
          const formProductsCount = Math.max(
            ...Object.keys(form.produtos[etapa[0]]).concat(0),
          );
          // For each of the existing step products, that is not on the editing fase
          // Sets to the updating step
          etapas
            .find((e) => e._id === form.local_id[etapa[0]])
            .produtos.filter((p) => p.fase_id !== form.fase_id)
            .forEach((p, i) => (x.produtos[i + formProductsCount + 1] = p));
        }
        const e = new Etapa({ ...x }, form.local_id[etapa[0]]);
        newEtapas.push(e);
      }).then(() => {
        let biggestId = -1;
        Helpers.asyncForEach(newEtapas, async (e) => {
          const isNewEtapa = e.isNewEtapa();
          await e.prepare();
          if (isNewEtapa && e._id <= biggestId) {
            e._id = biggestId + 1;
          }
          biggestId = e._id > biggestId ? e._id : biggestId;
          ids.push(e._id);
          etapasToCreate.push(e);
        })
          .then(() => Database.etapas.bulkPut(etapasToCreate))
          .then(() =>
            Database.etapas
              .filter(
                (e) =>
                  (e.pem_id === pemId || e.pem === pemId) &&
                  !orderCadastradas.includes(String(e.ordem)),
              )
              .delete(),
          )
          .then(() =>
            new Queue({
              url: `etapas/${pemId}`,
              table: 'etapas',
              localId: ids,
              requestBody: form,
            })
              .save()
              .then(() => {
                dispatch(queueCreators.getQueue());
              }),
          );
      });

      dispatch({ type: Types.UPDATE_ETAPAS_SUCCESS });
    } catch (oof) {
      const localCurb = await Database.etapas.filter((x) =>
        ids.map((y) => String(y)).includes(String(x)),
      );
      await localCurb.delete();
      console.error(oof.message);
      dispatch({
        type: Types.UPDATE_ETAPAS_FAILED,
        payload: { error: oof.message },
      });
    }
  },
};
